import React from "react";
import { Molecule, Wrapper, wrap } from "AppReact";
import styled, { css } from "styled-components";
import CloseButton from "./atoms/closeButton";

const template = styled.div``;

export default Molecule({
  template,
  type: "",
  atoms: [
    {
      component: CloseButton,
      name: "CloseButton",
      displayState: () => ({ size: "24px", viewBox: "0 0 36 36" }),
      displayValue: () => {
        const strokeLength = 10;
        const halfLength = strokeLength / 2;
        return (
        <>
          <g>
            <rect
              width="32"
              height="32"
              rx="16"
              transform="matrix(-1 0 0 1 34 1)"
              fill="white"
            />
            <rect
              x="-0.5"
              y="0.5"
              width="31"
              height="31"
              rx="15.5"
              transform="matrix(-1 0 0 1 33 1)"
            />
          </g>
          <path
            d={`M${18 - halfLength} ${18 - halfLength} L${18 + halfLength} ${18 + halfLength}`}
            stroke={window?.settings?.secondary_color ?? "#04333b"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d={`M${18 - halfLength} ${18 + halfLength} L${18 + halfLength} ${18 - halfLength}`}
            stroke={window?.settings?.secondary_color ?? "#04333b"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )},
    },
  ],
});
